<script setup lang="ts">
import Alert from '@/interfaces/Alert';
import ConnxTransition from '@/components/Atoms/ConnxTransition.vue';
import useFlashMessageStore from '@/stores/flash-messages';
import ConnxAlert from '../Molecules/ConnxAlert.vue';

const messageStore = useFlashMessageStore();

const removeAlert = (alert: Alert): void => {
  messageStore.removeNotification(alert);
};

</script>

<template>
  <Teleport to="body">
    <div class="tailwindcss">
      <div class="tw-fixed tw-bottom-2 tw-right-4 tw-z-alerts">
        <connx-transition :group="true" tag="div" name="alerts">
          <div v-for="(alert, index) in messageStore.messages" :key="index" class="tw-mb-2 tw-max-w-md">
            <connx-alert :aria-errormessage="alert.message" :type="alert.type" class="tw-cursor-pointer"
              @click="removeAlert(alert)">
              <div>
                <h6 v-if="alert.title" class="tw-text-connx-white tw-mb-2">
                  {{ alert.title }}
                </h6>
                {{ alert.message }}
              </div>
            </connx-alert>
          </div>
        </connx-transition>
      </div>
    </div>
  </Teleport>
</template>
